export var ChangeType;

(function (ChangeType) {
  ChangeType[ChangeType["CHANGE_TYPE_CREATE"] = 1] = "CHANGE_TYPE_CREATE";
  ChangeType[ChangeType["CHANGE_TYPE_UPDATE"] = 2] = "CHANGE_TYPE_UPDATE";
  ChangeType[ChangeType["CHANGE_TYPE_DELETE"] = 3] = "CHANGE_TYPE_DELETE";
  ChangeType[ChangeType["CHANGE_TYPE_START"] = 4] = "CHANGE_TYPE_START";
})(ChangeType || (ChangeType = {}));

export var ErrorType;

(function (ErrorType) {
  ErrorType["FieldValueError"] = "FieldValueError";
  ErrorType["FieldError"] = "FieldError";
  ErrorType["RowError"] = "RowError";
})(ErrorType || (ErrorType = {}));